// @flow
/** @jsx isolateComponent */

import { Avatar, GridCell, GridLayout, Text } from '@zapier/common-components';
import { getGravatarUrl, isolateComponent } from '@zapier/common-utils';

import type { TeamMemberType } from '@zapier/team/src/types';

type Props = {
  /** Member details */
  member: TeamMemberType,
};

const ZapOwner = ({ member }: Props) => {
  return (
    <article>
      <GridLayout
        alignItems="center"
        areas={`
        "avatar name"
        "email email"
        "remove remove"
      `}
        columns="36px 1fr"
        gap={8}
        propsQueries={{
          tabletLandscapePlus: {
            areas: '"avatar name email remove"',
            columns: '36px 1fr 1fr 98px',
            gap: 12,
          },
        }}
      >
        <GridCell area="avatar">
          <Avatar
            name={member.name || member.email}
            url={getGravatarUrl(member.avatarUrl)}
          />
        </GridCell>
        <GridCell area="name">
          <Text type="body-strong">{member.name}</Text>
        </GridCell>
        <GridCell area="email">
          <Text type="body">{member.email}</Text>
        </GridCell>
        <GridCell area="remove"></GridCell>
      </GridLayout>
    </article>
  );
};

export default ZapOwner;
